export default __webpack_public_path__ + "static/media/dimg4.f549a54a.jpg";